import Button from "../Button/Button";
import SongStyle from "../Song/SongStyle";
import { useDispatch, useSelector } from "react-redux";
import { deleteSongThunk } from "../../redux/thunks/songThunks";
import { useNavigate } from "react-router-dom";

const SongDetailsComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const song = useSelector((state) => state.oneSong);
  //const released = song.releaseDate.slice(0, 10); //original song.releaseDate
  // const released = song.releaseDate.toLocaleDateString();

  const handleDelete = () => {
    dispatch(deleteSongThunk(song._id));
  };

  const goToSonglistPage = () => {
    navigate("/songlist");
  };

  const deleteAndGoToSonglistPage = () => {
    handleDelete();
    goToSonglistPage();
  };

  return (
    <SongStyle>
      {song.artist && (
        <>
          <h1 className="songDetail-header">details</h1>
          <div className="songdetails-container">
            <ul className="song-collection__ul">
              <li className="song-container__songtitle">
                <span className="material-symbols-rounded">music_note</span>
                <h2 className="song-collection__title">{`${song.songTitle}`}</h2>
              </li>
              <li className="song-detail__song">
                <span className="material-symbols-rounded">person</span>
                <h3 className="song-detail__artist">{`${song.artist}`}</h3>
              </li>
              <li className="song-detail__document">
                <label htmlFor="song-detail__Tabs" className="label">
                  release date: {"  "}
                </label>
                <p className="song-detail__release">{` ${song.releaseDate.slice(
                  0,
                  10
                )}`}</p>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__lyrics detail-link"
                  href={`${song.documents.lyrics}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  lyrics
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__guitarTabs detail-link"
                  href={`${song.documents.guitarTabs}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  guitar tabs
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__guitarChords detail-link"
                  href={`${song.documents.guitarChords}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  guitar chords
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__bassTabs detail-link"
                  href={`${song.documents.bassTabs}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  bass
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__piano detail-link"
                  href={`${song.documents.piano}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  piano
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__drums detail-link"
                  href={`${song.documents.drums}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  drums
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__saxophone detail-link"
                  href={`${song.documents.saxophone}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  saxophone
                </a>
              </li>
              <li className="song-detail__document">
                <a
                  className="song-detail__trumpets detail-link"
                  href={`${song.documents.trumpets}`}
                  target="_blank"
                  rel="noreferrer"
                  styleType="primary"
                >
                  trumpets
                </a>
              </li>
              <li className="song-detail__youtube">
                <iframe
                  maxwidth="100%"
                  height="auto"
                  src={`https://www.youtube.com/embed/${song.youtubeVideo}`}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
              </li>

              <li className="song-details__button">
                <Button
                  text="home"
                  styleType="primary"
                  action={goToSonglistPage}
                />
                <button
                  className="secondary"
                  onClick={deleteAndGoToSonglistPage}
                >
                  delete
                </button>
              </li>
            </ul>
          </div>
        </>
      )}
    </SongStyle>
  );
};

export default SongDetailsComponent;
